import { render, staticRenderFns } from "./KYCRequestList.vue?vue&type=template&id=9a6d0c86&scoped=true"
import script from "./KYCRequestList.vue?vue&type=script&lang=js"
export * from "./KYCRequestList.vue?vue&type=script&lang=js"
import style0 from "./KYCRequestList.vue?vue&type=style&index=0&id=9a6d0c86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6d0c86",
  null
  
)

export default component.exports